import { render } from "./ImageDisplay.vue?vue&type=template&id=2d03de8a&scoped=true"
import script from "./ImageDisplay.vue?vue&type=script&lang=js"
export * from "./ImageDisplay.vue?vue&type=script&lang=js"

import "./ImageDisplay.vue?vue&type=style&index=0&id=2d03de8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d03de8a"]])

export default __exports__